export enum TagsQueryKeys {
	GetTags = 'GetTags',
	GetTagById = 'GetTagById',
	GetTagStatistics = 'GetTagStatistics',
	GetPlayersByTags = 'GetPlayersByTags',
}

export enum TagsMutationKeys {
	CreateTag = 'CreateTag',
	UpdateTag = 'UpdateTag',
	DeleteTag = 'DeleteTag',
	AssignTagsToPlayers = 'AssignTagsToPlayers',
	RemoveTagsFromPlayers = 'RemoveTagsFromPlayers',
}
